var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRadius0Icon = function SvgRadius0Icon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 2.75a.5.5 0 0 1 .5-.5h9.75a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5H4.5v8.75a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5V2.75Z",
    clipRule: "evenodd"
  })));
};
export default SvgRadius0Icon;